import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {TopSelect} from "./TopSelects";
import axios from "axios";

export default class TopSelectSlownik extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            options: []
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    componentDidMount() {

        if (Boolean(this.props.restUrl)) {
            axios({
                method: 'get',
                url: this.props.restUrl,
            }).then(function (response) {
                if (response) {
                    this.setState({options: response.data})
                    if (Boolean(this.props.defaultValue)){
                        this.setState({value: response.data.find(i=>i.wartosc==this.props.defaultValue)})

                    }
                }
            }.bind(this))
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.defaultValue)) {
            this.setState({value: this.state.options.find(i=>i.wartosc==nextprops.defaultValue)})
        }
    }

    onChangeSelect(e) {
        if (!this.props.clearable) {
            if (e !== null) {
                this.setState({value:e})
                this.props.onChange(e)
            }
        }
        else{
            this.props.onChange(e)
            this.setState({value:e})
        }
    }

    render() {
        return (
            <TopSelect name={this.props.name}
                       onChange={this.onChangeSelect}
                       value={this.state.value}
                       options={this.state.options}
                       disabled={this.props.disabled}
                       valueRenderer={this.props.valueRenderer}
                       optionRenderer={this.props.optionRenderer}
                       style={this.props.style}
                       className={this.props.className}
                       valueKey={this.props.valueKey}
                       labelKey={this.props.labelKey}
                       placeholder={this.props.placeholder}
                       clearable={this.props.clearable}
                       multi={this.props.multi}

            />
        );
    }
}

TopSelectSlownik.propTypes = {
    restUrl: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object,
    defaultValue: PropTypes.object,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    style:PropTypes.object,
    valueRenderer: PropTypes.func,
    optionRenderer: PropTypes.func,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    clearable:PropTypes.bool,
    multi:PropTypes.bool,
}

TopSelectSlownik.defaultProps = {
    name: 'form-field-name',
    placeholder: 'Wybierz...',
    clearable:true,
    multi:false,
    disabled: false,
};




// WEBPACK FOOTER //
// ./src/componentsTopsa/selects/TopSelectSlownik.js